import { ExportToCsv } from "export-to-csv";
import { handleError } from "../App";
import { WORKER_TYPES } from "../constants";
import { sleep } from "../dashboard/Common/helpers";
import { convertModels } from "../helpers/convertModels";
import {
  FAILED_STATUS,
  SUCCESS_STATUS,
} from "../MachineLearning/BackgroundTrainer";
import { getWorker } from "../MachineLearning/getWorker";
import { stateTypeF } from "../state";
export type batchDataType = { data: string[][]; headers: string[] };

async function processBatchDataInBackground(
  dataStr: string,
  state: stateTypeF
) {
  const convertedModels = convertModels(state.saveState.savedModels);
  let customTopics = state.saveState.dataset.visualizationData?.map(
    (v) => v.customTopicsData.customTopics
  );
  const payload = {
    workerType: WORKER_TYPES.batchPrediction,
    dataStr: dataStr,
    convertedModels: convertedModels,
    trainDataset: JSON.stringify(state.saveState.dataset),
    valueToPredict: state.saveState.modelTraining.valueToPredict,
    filters: state.saveState.cleanData.cleanDataFilters,
    customTopics: customTopics,
  };

  const worker = getWorker();

  let data: any[][];
  let headers: string[];
  let histData: number[][];
  let isValidated = false;
  let missingColumns: [];
  let resolves = {};

  let workerStatus = FAILED_STATUS;
  worker.onmessage = function (message) {
    if (message.data?.status) {
      data = message.data.data;
      headers = message.data.headers;
      histData = message.data.histData;
      isValidated = message.data.isValidated;
      missingColumns = message.data.missingColumns;
      resolves[0]();
      delete resolves[0];
      workerStatus = message.data.status;
    } else {
      handleError(state, message.data?.error, WORKER_TYPES.batchPrediction);
      resolves[0]();
      delete resolves[0];
    }
  };
  await new Promise(function (resolve, reject) {
    // save callbacks for later
    resolves[0] = resolve;
    worker.postMessage(payload);
  });
  if (workerStatus !== SUCCESS_STATUS) {
    return;
  }
  if (!isValidated) {
    let missing = Array.from(missingColumns).slice(0, 3);
    let additional = missingColumns.length - missing.length;
    let outStr =
      missing.join("', ") + (additional > 0 ? ` + ${additional} more...` : "");
    state.setRejectedReason(`Missing columns: ${outStr}`);
    state.setIsLoadingPopupOpen(false);
    state.setIsRejectedDropOpen(true);
    return;
  }

  state.saveState.batchPrediction.batchHistData = histData;
  state.saveState.batchPrediction.batchData = {
    data: data,
    headers: headers,
  };

  state.saveState.batchPrediction.batchFilteredData = data;
  state.setBatchFilteredData(data);
  state.setSaveState(state.saveState, true);
}

export default async function processBatchData(
  dataStr: string,
  state: stateTypeF
) {
  state.setBatchFilters([
    { column: "", operation: "", value: "", isValid: true },
  ]);

  let t0 = performance.now();
  state.setIsLoadingPopupOpen(true);
  await sleep(300);

  await processBatchDataInBackground(dataStr, state);
  let t1 = performance.now();
  let toSleep = 3000 - (t1 - t0);
  if (toSleep > 0) {
    await sleep(toSleep);
  }
  state.setIsLoadingPopupOpen(false);
  return;
}

export function downloadCSV(batchData: batchDataType) {
  let data = [];

  let nRows = batchData.data.length;
  for (let i = 0; i < nRows; i++) {
    let tmp = {};
    for (let h = 0; h < batchData.headers.length; h++) {
      tmp[h] = batchData.data[i][h];
    }
    data.push(tmp);
  }

  const options = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    showTitle: false,
    title: "My Awesome CSV",
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: false,
    headers: batchData.headers,
  };

  const csvExporter = new ExportToCsv(options);

  csvExporter.generateCsv(data);
}
